/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import { RecordingManagement } from './RecordingManagement';
import { ActivationCodes } from './ActivationCodes';
import { SequenceManagement } from './SequenceManagement';
import { ReanalysisManagement } from './reanalysis/ReanalysisManagement';
import { REANALYSIS_TAB, URL_KEYS } from './reanalysis/batchHistory';

// Tab order as rendered below. `?tab=<key>` opens a tab directly, so a shared
// link (e.g. a patient-filtered reanalysis view, #550) lands where it was taken.
const TAB_KEYS = ['recordings', 'activation-codes', 'sequences', REANALYSIS_TAB];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 1400,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
}));

export function AdminDashboard() {
  const classes = useStyles();
  const [params, setParams] = useSearchParams();
  const fromUrl = TAB_KEYS.indexOf(params.get(URL_KEYS.tab) ?? '');
  const value = fromUrl >= 0 ? fromUrl : 0;

  const handleChange = (event, newValue) => {
    const next = new URLSearchParams(params);

    next.set(URL_KEYS.tab, TAB_KEYS[newValue]);
    setParams(next, { replace: true });
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} aria-label="simple tabs example" onChange={handleChange}>
          <Tab label="Recordings" {...a11yProps(0)} />
          <Tab label="Activation Codes" {...a11yProps(1)} />
          <Tab label="Sequences" {...a11yProps(2)} />
          {/* project_management#514 — bulk reanalysis progress + history */}
          <Tab label="Reanalysis" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <RecordingManagement />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ActivationCodes />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SequenceManagement />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ReanalysisManagement />
      </TabPanel>
    </div>
  );
}
